import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import '../../assets/styles/ui-button.css'

interface ButtonProps {
    submitting: boolean;
    target: string;
    label?: string;
    className?: string;
    id: string;
    clickFunction?: (event: React.MouseEvent) => void;
    Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    variant?: string;
    type?: "button" | "submit" | "reset";
    style?: {};
    shakeInterval?: number; // in ms
}

const UIButton: React.FC<ButtonProps> = ({
                                             submitting,
                                             target,
                                             id,
                                             label,
                                             className,
                                             clickFunction = (e) => {
                                                 console.log('nothing here');
                                                 return;
                                             },
                                             Icon,
                                             variant = 'outline-primary',
                                             type = "button",
                                             style = { marginRight: '10px' },
                                             shakeInterval // new prop
                                         }) => {
    const { i18n } = useTranslation();
    // @ts-ignore
    const t = (txt: string) => i18n.t(txt);

    submitting = submitting && (target === id);

    const [shake, setShake] = useState(false);
    let shakeCount = 8;

    useEffect(() => {
        if (!shakeInterval || submitting) return;

        const interval = setInterval(() => {
            if(shakeCount <= 0) return;
            setShake(true);
            setTimeout(() => setShake(false), 600); // shake duration
            shakeCount--;
        }, shakeInterval);

        return () => clearInterval(interval);
    }, [shakeInterval, submitting]);

    return (
        <Button
            variant={variant}
            className={className}
            disabled={submitting}
            onClick={type === "button" ? clickFunction : undefined}
            style={style}
            type={type}
        >
            {submitting && (
                <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
            )}
            {Icon && !submitting && (
                <Icon
                    style={{
                        width: '25px',
                        height: '25px',
                        animation: shake ? 'shake 0.6s' : 'none',
                    }}
                />
            )}
            {label && (
                <span style={{
                    paddingLeft: '3px',
                    display: Icon ? 'block' : 'inline',
                }}>
                    {submitting ? t("Loading...") : t(label)}
                </span>
            )}
        </Button>
    );
};

const mapStateToProps = (state: any) => ({
    submitting: state.loaders.submitButton,
    target: state.loaders.target,
});

export default connect(mapStateToProps)(UIButton);
